// Terminología visual según el tipo de administración (Barrio Cerrado vs Edificio).
// Puramente de presentación: no cambia rutas, campos ni lógica, solo qué texto se muestra.
export const useTerminologia = () => {
    const tipoAdministracion = localStorage.getItem('tipoAdministracion') || 'Barrio Cerrado';
    const esEdificio = tipoAdministracion === 'Edificio';

    return {
        esEdificio,
        Barrio: esEdificio ? 'Edificio' : 'Barrio',
        barrio: esEdificio ? 'edificio' : 'barrio',
        Barrios: esEdificio ? 'Edificios' : 'Barrios',
        barrios: esEdificio ? 'edificios' : 'barrios',
        UnidadFuncional: esEdificio ? 'Departamento' : 'Unidad Funcional',
        unidadFuncional: esEdificio ? 'departamento' : 'unidad funcional',
        UnidadesFuncionales: esEdificio ? 'Departamentos' : 'Unidades Funcionales',
        unidadesFuncionales: esEdificio ? 'departamentos' : 'unidades funcionales',
        UF: esEdificio ? 'Depto' : 'UF',
        // Artículo indefinido correcto para "unidadFuncional" (un depto / una UF)
        unUnidadFuncional: esEdificio ? 'un departamento' : 'una unidad funcional',
    };
};
